import React, { FC } from 'react';
import DownloadTableCell from '../../configure/configuration-files/components/download-cell';
import useStyles from './styles';

const DownloadFile: FC<any> = (properties: {
  row: {
    original: {
      fileTypeId: string;
      id: string;
      fileName: string | null;
    };
  };
}) => {
  const classes = useStyles();
  const {
    row: {
      original: { fileTypeId, id: hash, fileName },
    },
  } = properties;
  return (
    <div className={classes.downloadIcon}>
      <DownloadTableCell row={{ fileTypeId, hash, fileName }} />
    </div>
  );
};

export default DownloadFile;
